export default {
  "10" : {
    "fuelScenarioValuesAllRegions": [
      {
        "regionId": "1",
        "year": 2010,
        "scenarioValue": 0.5477049647
      },
      {
        "regionId": "1",
        "year": 2020,
        "scenarioValue": 0.4670193343
      },
      {
        "regionId": "1",
        "year": 2030,
        "scenarioValue": 0.4337538448
      },
      {
        "regionId": "1",
        "year": 2040,
        "scenarioValue": 0.4199838079
      },
      {
        "regionId": "1",
        "year": 2050,
        "scenarioValue": 0.4932598971
      },
      {
        "regionId": "1",
        "year": 2060,
        "scenarioValue": 0.5191111342
      },
      {
        "regionId": "1",
        "year": 2070,
        "scenarioValue": 0.5418757281
      },
      {
        "regionId": "1",
        "year": 2080,
        "scenarioValue": 0.561553679
      },
      {
        "regionId": "1",
        "year": 2090,
        "scenarioValue": 0.5354676177
      },
      {
        "regionId": "1",
        "year": 2100,
        "scenarioValue": 0.5093815565
      },
      {
        "regionId": "2",
        "year": 2010,
        "scenarioValue": 0.8913362702
      },
      {
        "regionId": "2",
        "year": 2020,
        "scenarioValue": 0.7952262791
      },
      {
        "regionId": "2",
        "year": 2030,
        "scenarioValue": 0.8391980579
      },
      {
        "regionId": "2",
        "year": 2040,
        "scenarioValue": 0.8525867536
      },
      {
        "regionId": "2",
        "year": 2050,
        "scenarioValue": 0.8722409124
      },
      {
        "regionId": "2",
        "year": 2060,
        "scenarioValue": 0.8538822376
      },
      {
        "regionId": "2",
        "year": 2070,
        "scenarioValue": 0.8336846265
      },
      {
        "regionId": "2",
        "year": 2080,
        "scenarioValue": 0.8116480793
      },
      {
        "regionId": "2",
        "year": 2090,
        "scenarioValue": 0.8103813947
      },
      {
        "regionId": "2",
        "year": 2100,
        "scenarioValue": 0.8091147101
      },
      {
        "regionId": "3",
        "year": 2010,
        "scenarioValue": 0.8947454043
      },
      {
        "regionId": "3",
        "year": 2020,
        "scenarioValue": 0.7591346258
      },
      {
        "regionId": "3",
        "year": 2030,
        "scenarioValue": 0.8157955766
      },
      {
        "regionId": "3",
        "year": 2040,
        "scenarioValue": 0.8565541933
      },
      {
        "regionId": "3",
        "year": 2050,
        "scenarioValue": 0.8294794097
      },
      {
        "regionId": "3",
        "year": 2060,
        "scenarioValue": 0.8273264971
      },
      {
        "regionId": "3",
        "year": 2070,
        "scenarioValue": 0.826937306
      },
      {
        "regionId": "3",
        "year": 2080,
        "scenarioValue": 0.8283118365
      },
      {
        "regionId": "3",
        "year": 2090,
        "scenarioValue": 0.8186690591
      },
      {
        "regionId": "3",
        "year": 2100,
        "scenarioValue": 0.8090262818
      },
      {
        "regionId": "4",
        "year": 2010,
        "scenarioValue": 0.5983320831
      },
      {
        "regionId": "4",
        "year": 2020,
        "scenarioValue": 0.5611651147
      },
      {
        "regionId": "4",
        "year": 2030,
        "scenarioValue": 0.6114103835
      },
      {
        "regionId": "4",
        "year": 2040,
        "scenarioValue": 0.6682197065
      },
      {
        "regionId": "4",
        "year": 2050,
        "scenarioValue": 0.7224603639
      },
      {
        "regionId": "4",
        "year": 2060,
        "scenarioValue": 0.7727791196
      },
      {
        "regionId": "4",
        "year": 2070,
        "scenarioValue": 0.7951113186
      },
      {
        "regionId": "4",
        "year": 2080,
        "scenarioValue": 0.7894569612
      },
      {
        "regionId": "4",
        "year": 2090,
        "scenarioValue": 0.7580794545
      },
      {
        "regionId": "4",
        "year": 2100,
        "scenarioValue": 0.7267019478
      },
      {
        "regionId": "5",
        "year": 2010,
        "scenarioValue": 0.8322209729
      },
      {
        "regionId": "5",
        "year": 2020,
        "scenarioValue": 0.8058305833
      },
      {
        "regionId": "5",
        "year": 2030,
        "scenarioValue": 0.8703612457
      },
      {
        "regionId": "5",
        "year": 2040,
        "scenarioValue": 0.8885849032
      },
      {
        "regionId": "5",
        "year": 2050,
        "scenarioValue": 0.8969592914
      },
      {
        "regionId": "5",
        "year": 2060,
        "scenarioValue": 0.9070270116
      },
      {
        "regionId": "5",
        "year": 2070,
        "scenarioValue": 0.9174578878
      },
      {
        "regionId": "5",
        "year": 2080,
        "scenarioValue": 0.92825192
      },
      {
        "regionId": "5",
        "year": 2090,
        "scenarioValue": 0.9222556026
      },
      {
        "regionId": "5",
        "year": 2100,
        "scenarioValue": 0.9162592851
      },
      {
        "regionId": "6",
        "year": 2010,
        "scenarioValue": 0.6150632756
      },
      {
        "regionId": "6",
        "year": 2020,
        "scenarioValue": 0.566528486
      },
      {
        "regionId": "6",
        "year": 2030,
        "scenarioValue": 0.5878093132
      },
      {
        "regionId": "6",
        "year": 2040,
        "scenarioValue": 0.6098822842
      },
      {
        "regionId": "6",
        "year": 2050,
        "scenarioValue": 0.6351325047
      },
      {
        "regionId": "6",
        "year": 2060,
        "scenarioValue": 0.6051168892
      },
      {
        "regionId": "6",
        "year": 2070,
        "scenarioValue": 0.5841110909
      },
      {
        "regionId": "6",
        "year": 2080,
        "scenarioValue": 0.5721151096
      },
      {
        "regionId": "6",
        "year": 2090,
        "scenarioValue": 0.5230443936
      },
      {
        "regionId": "6",
        "year": 2100,
        "scenarioValue": 0.4739736777
      },
      {
        "regionId": "7",
        "year": 2010,
        "scenarioValue": 0.7570618641
      },
      {
        "regionId": "7",
        "year": 2020,
        "scenarioValue": 0.7397066342
      },
      {
        "regionId": "7",
        "year": 2030,
        "scenarioValue": 0.6782381883
      },
      {
        "regionId": "7",
        "year": 2040,
        "scenarioValue": 0.6358373703
      },
      {
        "regionId": "7",
        "year": 2050,
        "scenarioValue": 0.6793088976
      },
      {
        "regionId": "7",
        "year": 2060,
        "scenarioValue": 0.7095341581
      },
      {
        "regionId": "7",
        "year": 2070,
        "scenarioValue": 0.7237138048
      },
      {
        "regionId": "7",
        "year": 2080,
        "scenarioValue": 0.7218478376
      },
      {
        "regionId": "7",
        "year": 2090,
        "scenarioValue": 0.7147538432
      },
      {
        "regionId": "7",
        "year": 2100,
        "scenarioValue": 0.7076598487
      },
      {
        "regionId": "8",
        "year": 2010,
        "scenarioValue": 0.6634790528
      },
      {
        "regionId": "8",
        "year": 2020,
        "scenarioValue": 0.7560577185
      },
      {
        "regionId": "8",
        "year": 2030,
        "scenarioValue": 0.7904775315
      },
      {
        "regionId": "8",
        "year": 2040,
        "scenarioValue": 0.7926871719
      },
      {
        "regionId": "8",
        "year": 2050,
        "scenarioValue": 0.793417075
      },
      {
        "regionId": "8",
        "year": 2060,
        "scenarioValue": 0.7944197028
      },
      {
        "regionId": "8",
        "year": 2070,
        "scenarioValue": 0.7895000432
      },
      {
        "regionId": "8",
        "year": 2080,
        "scenarioValue": 0.7786580963
      },
      {
        "regionId": "8",
        "year": 2090,
        "scenarioValue": 0.7626340417
      },
      {
        "regionId": "8",
        "year": 2100,
        "scenarioValue": 0.7466099871
      },
      {
        "regionId": "9",
        "year": 2010,
        "scenarioValue": 0.9234408406
      },
      {
        "regionId": "9",
        "year": 2020,
        "scenarioValue": 0.920839656
      },
      {
        "regionId": "9",
        "year": 2030,
        "scenarioValue": 0.9219550167
      },
      {
        "regionId": "9",
        "year": 2040,
        "scenarioValue": 0.931176029
      },
      {
        "regionId": "9",
        "year": 2050,
        "scenarioValue": 0.937763284
      },
      {
        "regionId": "9",
        "year": 2060,
        "scenarioValue": 0.9422837937
      },
      {
        "regionId": "9",
        "year": 2070,
        "scenarioValue": 0.9451069509
      },
      {
        "regionId": "9",
        "year": 2080,
        "scenarioValue": 0.9462327556
      },
      {
        "regionId": "9",
        "year": 2090,
        "scenarioValue": 0.9482486354
      },
      {
        "regionId": "9",
        "year": 2100,
        "scenarioValue": 0.9502645152
      },
      {
        "regionId": "10",
        "year": 2010,
        "scenarioValue": 0.9587446452
      },
      {
        "regionId": "10",
        "year": 2020,
        "scenarioValue": 0.9109333471
      },
      {
        "regionId": "10",
        "year": 2030,
        "scenarioValue": 0.8945828685
      },
      {
        "regionId": "10",
        "year": 2040,
        "scenarioValue": 0.7782256513
      },
      {
        "regionId": "10",
        "year": 2050,
        "scenarioValue": 0.7877711181
      },
      {
        "regionId": "10",
        "year": 2060,
        "scenarioValue": 0.7964509347
      },
      {
        "regionId": "10",
        "year": 2070,
        "scenarioValue": 0.8068802609
      },
      {
        "regionId": "10",
        "year": 2080,
        "scenarioValue": 0.8190590964
      },
      {
        "regionId": "10",
        "year": 2090,
        "scenarioValue": 0.8317303306
      },
      {
        "regionId": "10",
        "year": 2100,
        "scenarioValue": 0.8444015648
      },
      {
        "regionId": "11",
        "year": 2010,
        "scenarioValue": 0.8328834356
      },
      {
        "regionId": "11",
        "year": 2020,
        "scenarioValue": 0.8386727689
      },
      {
        "regionId": "11",
        "year": 2030,
        "scenarioValue": 0.8643068507
      },
      {
        "regionId": "11",
        "year": 2040,
        "scenarioValue": 0.890695326
      },
      {
        "regionId": "11",
        "year": 2050,
        "scenarioValue": 0.8725685327
      },
      {
        "regionId": "11",
        "year": 2060,
        "scenarioValue": 0.8620528498
      },
      {
        "regionId": "11",
        "year": 2070,
        "scenarioValue": 0.8586616141
      },
      {
        "regionId": "11",
        "year": 2080,
        "scenarioValue": 0.8623948256
      },
      {
        "regionId": "11",
        "year": 2090,
        "scenarioValue": 0.8072843693
      },
      {
        "regionId": "11",
        "year": 2100,
        "scenarioValue": 0.752173913
      },
      {
        "regionId": "12",
        "year": 2010,
        "scenarioValue": 0.7131313278
      },
      {
        "regionId": "12",
        "year": 2020,
        "scenarioValue": 0.7106985238
      },
      {
        "regionId": "12",
        "year": 2030,
        "scenarioValue": 0.7542133163
      },
      {
        "regionId": "12",
        "year": 2040,
        "scenarioValue": 0.7861725988
      },
      {
        "regionId": "12",
        "year": 2050,
        "scenarioValue": 0.7616745625
      },
      {
        "regionId": "12",
        "year": 2060,
        "scenarioValue": 0.7774282021
      },
      {
        "regionId": "12",
        "year": 2070,
        "scenarioValue": 0.7826507231
      },
      {
        "regionId": "12",
        "year": 2080,
        "scenarioValue": 0.7773421256
      },
      {
        "regionId": "12",
        "year": 2090,
        "scenarioValue": 0.7704574248
      },
      {
        "regionId": "12",
        "year": 2100,
        "scenarioValue": 0.7635727239
      },
      {
        "regionId": "13",
        "year": 2010,
        "scenarioValue": 0.8034570973
      },
      {
        "regionId": "13",
        "year": 2020,
        "scenarioValue": 0.8176694474
      },
      {
        "regionId": "13",
        "year": 2030,
        "scenarioValue": 0.8511335112
      },
      {
        "regionId": "13",
        "year": 2040,
        "scenarioValue": 0.8672360631
      },
      {
        "regionId": "13",
        "year": 2050,
        "scenarioValue": 0.8823871552
      },
      {
        "regionId": "13",
        "year": 2060,
        "scenarioValue": 0.8805514453
      },
      {
        "regionId": "13",
        "year": 2070,
        "scenarioValue": 0.8623943949
      },
      {
        "regionId": "13",
        "year": 2080,
        "scenarioValue": 0.8279160037
      },
      {
        "regionId": "13",
        "year": 2090,
        "scenarioValue": 0.8268525455
      },
      {
        "regionId": "13",
        "year": 2100,
        "scenarioValue": 0.8257890874
      },
      {
        "regionId": "14",
        "year": 2010,
        "scenarioValue": 0.8502430229
      },
      {
        "regionId": "14",
        "year": 2020,
        "scenarioValue": 0.9170775333
      },
      {
        "regionId": "14",
        "year": 2030,
        "scenarioValue": 0.8109903104
      },
      {
        "regionId": "14",
        "year": 2040,
        "scenarioValue": 0.855554356
      },
      {
        "regionId": "14",
        "year": 2050,
        "scenarioValue": 0.8514830058
      },
      {
        "regionId": "14",
        "year": 2060,
        "scenarioValue": 0.883655668
      },
      {
        "regionId": "14",
        "year": 2070,
        "scenarioValue": 0.9093502391
      },
      {
        "regionId": "14",
        "year": 2080,
        "scenarioValue": 0.928566719
      },
      {
        "regionId": "14",
        "year": 2090,
        "scenarioValue": 0.9003572773
      },
      {
        "regionId": "14",
        "year": 2100,
        "scenarioValue": 0.8721478356
      },
      {
        "regionId": "15",
        "year": 2010,
        "scenarioValue": 0.8500695819
      },
      {
        "regionId": "15",
        "year": 2020,
        "scenarioValue": 0.8143507757
      },
      {
        "regionId": "15",
        "year": 2030,
        "scenarioValue": 0.7930375623
      },
      {
        "regionId": "15",
        "year": 2040,
        "scenarioValue": 0.7872440457
      },
      {
        "regionId": "15",
        "year": 2050,
        "scenarioValue": 0.825743904
      },
      {
        "regionId": "15",
        "year": 2060,
        "scenarioValue": 0.8605074464
      },
      {
        "regionId": "15",
        "year": 2070,
        "scenarioValue": 0.90887122
      },
      {
        "regionId": "15",
        "year": 2080,
        "scenarioValue": 0.9708352247
      },
      {
        "regionId": "15",
        "year": 2090,
        "scenarioValue": 0.9757571573
      },
      {
        "regionId": "15",
        "year": 2100,
        "scenarioValue": 0.98067909
      },
      {
        "regionId": "16",
        "year": 2010,
        "scenarioValue": 0.8769919497
      },
      {
        "regionId": "16",
        "year": 2020,
        "scenarioValue": 0.8639080187
      },
      {
        "regionId": "16",
        "year": 2030,
        "scenarioValue": 0.875185054
      },
      {
        "regionId": "16",
        "year": 2040,
        "scenarioValue": 0.9167337805
      },
      {
        "regionId": "16",
        "year": 2050,
        "scenarioValue": 0.9371766772
      },
      {
        "regionId": "16",
        "year": 2060,
        "scenarioValue": 0.9213352242
      },
      {
        "regionId": "16",
        "year": 2070,
        "scenarioValue": 0.9051583625
      },
      {
        "regionId": "16",
        "year": 2080,
        "scenarioValue": 0.8886460921
      },
      {
        "regionId": "16",
        "year": 2090,
        "scenarioValue": 0.8793928801
      },
      {
        "regionId": "16",
        "year": 2100,
        "scenarioValue": 0.8701396681
      },
      {
        "regionId": "0",
        "year": 2010,
        "scenarioValue": 0.7982245084
      },
      {
        "regionId": "0",
        "year": 2020,
        "scenarioValue": 0.78924857
      },
      {
        "regionId": "0",
        "year": 2030,
        "scenarioValue": 0.7937422738
      },
      {
        "regionId": "0",
        "year": 2040,
        "scenarioValue": 0.8019295992
      },
      {
        "regionId": "0",
        "year": 2050,
        "scenarioValue": 0.815133568
      },
      {
        "regionId": "0",
        "year": 2060,
        "scenarioValue": 0.8186982479
      },
      {
        "regionId": "0",
        "year": 2070,
        "scenarioValue": 0.8187266424
      },
      {
        "regionId": "0",
        "year": 2080,
        "scenarioValue": 0.8152187516
      },
      {
        "regionId": "0",
        "year": 2090,
        "scenarioValue": 0.7969864544
      },
      {
        "regionId": "0",
        "year": 2100,
        "scenarioValue": 0.7787541572
      }
    ],
    "factor": {
      "id": "10",
      "unit": "Share",
      "unitShort": "Share",
      "title": "Fossil fuel - Primary energy"
    }
  },
  "11" : {
    "fuelScenarioValuesAllRegions": [
      {
        "regionId": "1",
        "year": 2010,
        "scenarioValue": 0.7820752086
      },
      {
        "regionId": "1",
        "year": 2020,
        "scenarioValue": 0.6166209818
      },
      {
        "regionId": "1",
        "year": 2030,
        "scenarioValue": 0.4815972392
      },
      {
        "regionId": "1",
        "year": 2040,
        "scenarioValue": 0.3128144151
      },
      {
        "regionId": "1",
        "year": 2050,
        "scenarioValue": 0.4097631097
      },
      {
        "regionId": "1",
        "year": 2060,
        "scenarioValue": 0.3818098016
      },
      {
        "regionId": "1",
        "year": 2070,
        "scenarioValue": 0.3657240357
      },
      {
        "regionId": "1",
        "year": 2080,
        "scenarioValue": 0.361505812
      },
      {
        "regionId": "1",
        "year": 2090,
        "scenarioValue": 0.4038759936
      },
      {
        "regionId": "1",
        "year": 2100,
        "scenarioValue": 0.4462461752
      },
      {
        "regionId": "2",
        "year": 2010,
        "scenarioValue": 0.8258076728
      },
      {
        "regionId": "2",
        "year": 2020,
        "scenarioValue": 0.6368163814
      },
      {
        "regionId": "2",
        "year": 2030,
        "scenarioValue": 0.738738853
      },
      {
        "regionId": "2",
        "year": 2040,
        "scenarioValue": 0.7734474679
      },
      {
        "regionId": "2",
        "year": 2050,
        "scenarioValue": 0.8100209885
      },
      {
        "regionId": "2",
        "year": 2060,
        "scenarioValue": 0.7867447365
      },
      {
        "regionId": "2",
        "year": 2070,
        "scenarioValue": 0.7647142854
      },
      {
        "regionId": "2",
        "year": 2080,
        "scenarioValue": 0.7439296351
      },
      {
        "regionId": "2",
        "year": 2090,
        "scenarioValue": 0.7455713327
      },
      {
        "regionId": "2",
        "year": 2100,
        "scenarioValue": 0.7472130303
      },
      {
        "regionId": "3",
        "year": 2010,
        "scenarioValue": 0.7166460404
      },
      {
        "regionId": "3",
        "year": 2020,
        "scenarioValue": 0.4424675757
      },
      {
        "regionId": "3",
        "year": 2030,
        "scenarioValue": 0.6376316143
      },
      {
        "regionId": "3",
        "year": 2040,
        "scenarioValue": 0.7502380797
      },
      {
        "regionId": "3",
        "year": 2050,
        "scenarioValue": 0.7183804492
      },
      {
        "regionId": "3",
        "year": 2060,
        "scenarioValue": 0.7185816432
      },
      {
        "regionId": "3",
        "year": 2070,
        "scenarioValue": 0.7219477805
      },
      {
        "regionId": "3",
        "year": 2080,
        "scenarioValue": 0.7284788612
      },
      {
        "regionId": "3",
        "year": 2090,
        "scenarioValue": 0.7319563985
      },
      {
        "regionId": "3",
        "year": 2100,
        "scenarioValue": 0.7354339359
      },
      {
        "regionId": "4",
        "year": 2010,
        "scenarioValue": 0.1832487218
      },
      {
        "regionId": "4",
        "year": 2020,
        "scenarioValue": 0.071704035
      },
      {
        "regionId": "4",
        "year": 2030,
        "scenarioValue": 0.1838736922
      },
      {
        "regionId": "4",
        "year": 2040,
        "scenarioValue": 0.312770191
      },
      {
        "regionId": "4",
        "year": 2050,
        "scenarioValue": 0.4246436562
      },
      {
        "regionId": "4",
        "year": 2060,
        "scenarioValue": 0.5671429083
      },
      {
        "regionId": "4",
        "year": 2070,
        "scenarioValue": 0.6538666445
      },
      {
        "regionId": "4",
        "year": 2080,
        "scenarioValue": 0.6848148648
      },
      {
        "regionId": "4",
        "year": 2090,
        "scenarioValue": 0.7012676605
      },
      {
        "regionId": "4",
        "year": 2100,
        "scenarioValue": 0.7177204563
      },
      {
        "regionId": "5",
        "year": 2010,
        "scenarioValue": 0.7738704483
      },
      {
        "regionId": "5",
        "year": 2020,
        "scenarioValue": 0.7317963337
      },
      {
        "regionId": "5",
        "year": 2030,
        "scenarioValue": 0.7701863768
      },
      {
        "regionId": "5",
        "year": 2040,
        "scenarioValue": 0.8079087823
      },
      {
        "regionId": "5",
        "year": 2050,
        "scenarioValue": 0.823205862
      },
      {
        "regionId": "5",
        "year": 2060,
        "scenarioValue": 0.8472794979
      },
      {
        "regionId": "5",
        "year": 2070,
        "scenarioValue": 0.8634841926
      },
      {
        "regionId": "5",
        "year": 2080,
        "scenarioValue": 0.8718199463
      },
      {
        "regionId": "5",
        "year": 2090,
        "scenarioValue": 0.8745747655
      },
      {
        "regionId": "5",
        "year": 2100,
        "scenarioValue": 0.8773295846
      },
      {
        "regionId": "6",
        "year": 2010,
        "scenarioValue": 0.1497080499
      },
      {
        "regionId": "6",
        "year": 2020,
        "scenarioValue": 0.039780821
      },
      {
        "regionId": "6",
        "year": 2030,
        "scenarioValue": 0.14032082
      },
      {
        "regionId": "6",
        "year": 2040,
        "scenarioValue": 0.2146311175
      },
      {
        "regionId": "6",
        "year": 2050,
        "scenarioValue": 0.2544591599
      },
      {
        "regionId": "6",
        "year": 2060,
        "scenarioValue": 0.2141446436
      },
      {
        "regionId": "6",
        "year": 2070,
        "scenarioValue": 0.2048529923
      },
      {
        "regionId": "6",
        "year": 2080,
        "scenarioValue": 0.2265842061
      },
      {
        "regionId": "6",
        "year": 2090,
        "scenarioValue": 0.2437435028
      },
      {
        "regionId": "6",
        "year": 2100,
        "scenarioValue": 0.2609027995
      },
      {
        "regionId": "7",
        "year": 2010,
        "scenarioValue": 0.4233683205
      },
      {
        "regionId": "7",
        "year": 2020,
        "scenarioValue": 0.3836247269
      },
      {
        "regionId": "7",
        "year": 2030,
        "scenarioValue": 0.247536327
      },
      {
        "regionId": "7",
        "year": 2040,
        "scenarioValue": 0.1459802888
      },
      {
        "regionId": "7",
        "year": 2050,
        "scenarioValue": 0.220893764
      },
      {
        "regionId": "7",
        "year": 2060,
        "scenarioValue": 0.3290427802
      },
      {
        "regionId": "7",
        "year": 2070,
        "scenarioValue": 0.3943144549
      },
      {
        "regionId": "7",
        "year": 2080,
        "scenarioValue": 0.4167087879
      },
      {
        "regionId": "7",
        "year": 2090,
        "scenarioValue": 0.4433007967
      },
      {
        "regionId": "7",
        "year": 2100,
        "scenarioValue": 0.4698928055
      },
      {
        "regionId": "8",
        "year": 2010,
        "scenarioValue": 0.755437654
      },
      {
        "regionId": "8",
        "year": 2020,
        "scenarioValue": 0.8171702951
      },
      {
        "regionId": "8",
        "year": 2030,
        "scenarioValue": 0.861361243
      },
      {
        "regionId": "8",
        "year": 2040,
        "scenarioValue": 0.8202355113
      },
      {
        "regionId": "8",
        "year": 2050,
        "scenarioValue": 0.8121675328
      },
      {
        "regionId": "8",
        "year": 2060,
        "scenarioValue": 0.792751898
      },
      {
        "regionId": "8",
        "year": 2070,
        "scenarioValue": 0.7776609059
      },
      {
        "regionId": "8",
        "year": 2080,
        "scenarioValue": 0.7668945565
      },
      {
        "regionId": "8",
        "year": 2090,
        "scenarioValue": 0.7607897259
      },
      {
        "regionId": "8",
        "year": 2100,
        "scenarioValue": 0.7546848953
      },
      {
        "regionId": "9",
        "year": 2010,
        "scenarioValue": 0.8418929478
      },
      {
        "regionId": "9",
        "year": 2020,
        "scenarioValue": 0.8363138418
      },
      {
        "regionId": "9",
        "year": 2030,
        "scenarioValue": 0.8457943234
      },
      {
        "regionId": "9",
        "year": 2040,
        "scenarioValue": 0.8541291484
      },
      {
        "regionId": "9",
        "year": 2050,
        "scenarioValue": 0.8941424222
      },
      {
        "regionId": "9",
        "year": 2060,
        "scenarioValue": 0.9029933631
      },
      {
        "regionId": "9",
        "year": 2070,
        "scenarioValue": 0.9095562949
      },
      {
        "regionId": "9",
        "year": 2080,
        "scenarioValue": 0.9138312176
      },
      {
        "regionId": "9",
        "year": 2090,
        "scenarioValue": 0.9175177808
      },
      {
        "regionId": "9",
        "year": 2100,
        "scenarioValue": 0.9212043441
      },
      {
        "regionId": "10",
        "year": 2010,
        "scenarioValue": 0.8747145209
      },
      {
        "regionId": "10",
        "year": 2020,
        "scenarioValue": 0.920781627
      },
      {
        "regionId": "10",
        "year": 2030,
        "scenarioValue": 0.8648352872
      },
      {
        "regionId": "10",
        "year": 2040,
        "scenarioValue": 0.4058868003
      },
      {
        "regionId": "10",
        "year": 2050,
        "scenarioValue": 0.4295702845
      },
      {
        "regionId": "10",
        "year": 2060,
        "scenarioValue": 0.4497836775
      },
      {
        "regionId": "10",
        "year": 2070,
        "scenarioValue": 0.4791398485
      },
      {
        "regionId": "10",
        "year": 2080,
        "scenarioValue": 0.5176387975
      },
      {
        "regionId": "10",
        "year": 2090,
        "scenarioValue": 0.5600642376
      },
      {
        "regionId": "10",
        "year": 2100,
        "scenarioValue": 0.6024896778
      },
      {
        "regionId": "11",
        "year": 2010,
        "scenarioValue": 0.7683277322
      },
      {
        "regionId": "11",
        "year": 2020,
        "scenarioValue": 0.7473556848
      },
      {
        "regionId": "11",
        "year": 2030,
        "scenarioValue": 0.7926662535
      },
      {
        "regionId": "11",
        "year": 2040,
        "scenarioValue": 0.8391275687
      },
      {
        "regionId": "11",
        "year": 2050,
        "scenarioValue": 0.8082343545
      },
      {
        "regionId": "11",
        "year": 2060,
        "scenarioValue": 0.8015279604
      },
      {
        "regionId": "11",
        "year": 2070,
        "scenarioValue": 0.8060575095
      },
      {
        "regionId": "11",
        "year": 2080,
        "scenarioValue": 0.8218230015
      },
      {
        "regionId": "11",
        "year": 2090,
        "scenarioValue": 0.8344423753
      },
      {
        "regionId": "11",
        "year": 2100,
        "scenarioValue": 0.8470617492
      },
      {
        "regionId": "12",
        "year": 2010,
        "scenarioValue": 0.7098449775
      },
      {
        "regionId": "12",
        "year": 2020,
        "scenarioValue": 0.6716562669
      },
      {
        "regionId": "12",
        "year": 2030,
        "scenarioValue": 0.7320564937
      },
      {
        "regionId": "12",
        "year": 2040,
        "scenarioValue": 0.7642964156
      },
      {
        "regionId": "12",
        "year": 2050,
        "scenarioValue": 0.6370719325
      },
      {
        "regionId": "12",
        "year": 2060,
        "scenarioValue": 0.6416084839
      },
      {
        "regionId": "12",
        "year": 2070,
        "scenarioValue": 0.65125779
      },
      {
        "regionId": "12",
        "year": 2080,
        "scenarioValue": 0.6660198508
      },
      {
        "regionId": "12",
        "year": 2090,
        "scenarioValue": 0.6830520215
      },
      {
        "regionId": "12",
        "year": 2100,
        "scenarioValue": 0.7000841923
      },
      {
        "regionId": "13",
        "year": 2010,
        "scenarioValue": 0.4728007132
      },
      {
        "regionId": "13",
        "year": 2020,
        "scenarioValue": 0.5349674156
      },
      {
        "regionId": "13",
        "year": 2030,
        "scenarioValue": 0.6607971698
      },
      {
        "regionId": "13",
        "year": 2040,
        "scenarioValue": 0.713681321
      },
      {
        "regionId": "13",
        "year": 2050,
        "scenarioValue": 0.7549716304
      },
      {
        "regionId": "13",
        "year": 2060,
        "scenarioValue": 0.750566879
      },
      {
        "regionId": "13",
        "year": 2070,
        "scenarioValue": 0.7121651477
      },
      {
        "regionId": "13",
        "year": 2080,
        "scenarioValue": 0.6397664363
      },
      {
        "regionId": "13",
        "year": 2090,
        "scenarioValue": 0.6436629029
      },
      {
        "regionId": "13",
        "year": 2100,
        "scenarioValue": 0.6475593695
      },
      {
        "regionId": "14",
        "year": 2010,
        "scenarioValue": 0.5903980935
      },
      {
        "regionId": "14",
        "year": 2020,
        "scenarioValue": 0.455018665
      },
      {
        "regionId": "14",
        "year": 2030,
        "scenarioValue": 0.5195404745
      },
      {
        "regionId": "14",
        "year": 2040,
        "scenarioValue": 0.6296231792
      },
      {
        "regionId": "14",
        "year": 2050,
        "scenarioValue": 0.6192604443
      },
      {
        "regionId": "14",
        "year": 2060,
        "scenarioValue": 0.7097969121
      },
      {
        "regionId": "14",
        "year": 2070,
        "scenarioValue": 0.7805280573
      },
      {
        "regionId": "14",
        "year": 2080,
        "scenarioValue": 0.8314538799
      },
      {
        "regionId": "14",
        "year": 2090,
        "scenarioValue": 0.8388799317
      },
      {
        "regionId": "14",
        "year": 2100,
        "scenarioValue": 0.8463059834
      },
      {
        "regionId": "15",
        "year": 2010,
        "scenarioValue": 0.6658112744
      },
      {
        "regionId": "15",
        "year": 2020,
        "scenarioValue": 0.6001164405
      },
      {
        "regionId": "15",
        "year": 2030,
        "scenarioValue": 0.572245282
      },
      {
        "regionId": "15",
        "year": 2040,
        "scenarioValue": 0.5793771475
      },
      {
        "regionId": "15",
        "year": 2050,
        "scenarioValue": 0.6673792313
      },
      {
        "regionId": "15",
        "year": 2060,
        "scenarioValue": 0.7484069231
      },
      {
        "regionId": "15",
        "year": 2070,
        "scenarioValue": 0.8487448955
      },
      {
        "regionId": "15",
        "year": 2080,
        "scenarioValue": 0.9683931485
      },
      {
        "regionId": "15",
        "year": 2090,
        "scenarioValue": 0.9777478973
      },
      {
        "regionId": "15",
        "year": 2100,
        "scenarioValue": 0.9871026461
      },
      {
        "regionId": "16",
        "year": 2010,
        "scenarioValue": 0.6946435879
      },
      {
        "regionId": "16",
        "year": 2020,
        "scenarioValue": 0.6552104185
      },
      {
        "regionId": "16",
        "year": 2030,
        "scenarioValue": 0.7108133008
      },
      {
        "regionId": "16",
        "year": 2040,
        "scenarioValue": 0.8126555877
      },
      {
        "regionId": "16",
        "year": 2050,
        "scenarioValue": 0.8481463833
      },
      {
        "regionId": "16",
        "year": 2060,
        "scenarioValue": 0.8321602107
      },
      {
        "regionId": "16",
        "year": 2070,
        "scenarioValue": 0.8198437702
      },
      {
        "regionId": "16",
        "year": 2080,
        "scenarioValue": 0.811197062
      },
      {
        "regionId": "16",
        "year": 2090,
        "scenarioValue": 0.821062056
      },
      {
        "regionId": "16",
        "year": 2100,
        "scenarioValue": 0.8309270501
      },
      {
        "regionId": "0",
        "year": 2010,
        "scenarioValue": 0.6386417632
      },
      {
        "regionId": "0",
        "year": 2020,
        "scenarioValue": 0.6233607872
      },
      {
        "regionId": "0",
        "year": 2030,
        "scenarioValue": 0.6500284903
      },
      {
        "regionId": "0",
        "year": 2040,
        "scenarioValue": 0.6589369105
      },
      {
        "regionId": "0",
        "year": 2050,
        "scenarioValue": 0.6815375818
      },
      {
        "regionId": "0",
        "year": 2060,
        "scenarioValue": 0.6950628979
      },
      {
        "regionId": "0",
        "year": 2070,
        "scenarioValue": 0.70114683
      },
      {
        "regionId": "0",
        "year": 2080,
        "scenarioValue": 0.6997893778
      },
      {
        "regionId": "0",
        "year": 2090,
        "scenarioValue": 0.7064009982
      },
      {
        "regionId": "0",
        "year": 2100,
        "scenarioValue": 0.7130126186
      }
    ],
    "factor": {
      "id": "11",
      "unit": "Share",
      "unitShort": "Share",
      "title": "Fossil fuel - Electricity"
    }    
  }
}